<template>
  <div>
    <template v-if="initialLoad">
      <v-content color="primary" v-if="valid">
        <v-container fill-height fluid>
          <v-layout align-center justify-center>
            <v-flex md4 sm8 xs12>
              <p class="headline text-xs-center">
                {{ $t('labels.unlockText') }}
              </p>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
      <v-content v-if="!valid">
        <v-container fill-height fluid>
          <v-layout align-center justify-center>
            <v-flex md4 sm8 xs12>
              <p class="headline text-xs-center">
                {{ $t('ballot.wrongTokenPreview') }}
              </p>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
    </template>
  </div>
</template>

<script>
import handle_session_error from '@/helpers/handle_session_error.js'

export default {
  name: 'AccountUnlock',
  props: ['token'],
  data() {
    return {
      initialLoad: false,
      valid: false,
    }
  },
  mounted() {
    let vm = this
    this.$APICall(
      'get',
      'ACCOUNT_UNLOCK',
      '/' + this.$route.params.token,
      {},
      data => {
        vm.$i18n.locale = data.language
        vm.valid = data.success
        vm.initialLoad = true
      },
      true,
      error => {
        handle_session_error(error, this.$store, this.$router, this.$prompt)
      }
    )
  },
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.forgot-button {
  cursor: pointer;
  color: #607d8b;
}

.fair-title {
  color: #607d8b;
}

.login-card {
  border: 2px solid #e8e8e8 !important;
}

.login-overlay {
  min-height: 720px;
  height: 100vh;
  width: 100vw;
  margin: -24px;
  text-align: center;
  padding: 0px;
  padding-top: 90px;
  color: #4b4b4b;
  background-color: #ffffff;
}

.login-inner {
  margin-left: auto;
  margin-right: auto;
  max-width: 556px;
}

.login-inner img {
  margin-bottom: 78px;
}
</style>
